import ErrorNotification from "./ErrorNotification";
export default ErrorNotification;
